import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import './Comparison.css'; // Import your CSS for styling

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function standardize(values) {
    const mean = values.reduce((a, b) => a + b, 0) / values.length;
    const std = Math.sqrt(values.reduce((a, b) => a + (b - mean) ** 2, 0) / values.length);
    return values.map(x => (x - mean) / std);
}

function normalize(values, minVal = -1, maxVal = 1) {
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1; // avoid division by zero

    return values.map(v => ((v - min) / range) * (maxVal - minVal) + minVal);
}

function buildChartConfig(title, labels, values) {
    const sorted = labels.map((label, i) => ({ label, value: values[i] }))
                        .sort((a, b) => b.value - a.value);

    const sortedLabels = sorted.map(d => d.label);
    const sortedValues = sorted.map(d => d.value);

    return {
        data: {
            labels: sortedLabels,
            datasets: [{
                label: title,
                data: sortedValues,
                backgroundColor: '#c62828', //sortedValues.map(v => v > 0 ? 'rgba(75, 192, 192, 0.6)' : 'rgba(255, 99, 132, 0.6)'),
            }]
        },
        options: {
            maintainAspectRatio: false,
            indexAxis: 'y',
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: title,
                    position: 'bottom',
                },
                legend: { display: false },
            },
            scales: {
                x: {
                    beginAtZero: true,
                },
                y: {
                    ticks: {
                        autoSkip: false,
                    }
                }
            },
        },
    };
}

export function computedClickStats(data) {
    const names = data.map(d => d.name);
    const zBreadth = normalize(data.map(d => d.breadth));
    const zDepth = normalize(data.map(d => d.depth));
    const zPattern = normalize(data.map(d => d.pattern));
    return { names, zBreadth, zDepth, zPattern };
}

export default function ClickBarChart({ data }) {
    const names = data.map(d => d.name);
    const zBreadth = normalize(data.map(d => d.breadth));
    const zDepth = normalize(data.map(d => d.depth));
    const zPattern = normalize(data.map(d => d.pattern));

    const charts = [
        buildChartConfig('Breadth', names, zBreadth),
        buildChartConfig('Depth', names, zDepth),
        buildChartConfig('Pattern', names, zPattern),
    ];

    return (
        <div className="click-bar-chart">
            {charts.map((chart, index) => (
                <div key={index} className="click-bar-chart-container" >
                    <Bar data={chart.data} options={chart.options} />
                </div>
            ))}
        </div>
    );
}